export const DASHLY_PERMISSIONS = {
    OBJECTIVE_VIEW: "Objective.View",
    OBJECTIVE_ADD: "Objective.Add",
    OBJECTIVE_EDIT: "Objective.Edit",
    OBJECTIVE_DELETE: "Objective.Delete",

    ALERT_VIEW: "Alert.View",
    ALERT_ADD: "Alert.Add",
    ALERT_EDIT: "Alert.Edit",
    ALERT_DELETE: "Alert.Delete",

    PROCESSFLOW_VIEW: "Processflow.View",
    PROCESSFLOW_ADD: "Processflow.Add",
    PROCESSFLOW_EDIT: "Processflow.Edit",
    PROCESSFLOW_DELETE: "Processflow.Delete",

    PROJECT_VIEW: "Project.View",
    PROJECT_ADD: "Project.Add",
    PROJECT_EDIT: "Project.Edit",
    PROJECT_DELETE: "Project.Delete",
    PROJECT_APPROVE_CUSTOMER: "Project.Approve.Customer",
    PROJECT_APPROVE_DASHLY: "Project.Approve.Dashly",
    PROJECT_PHASE_ADVANCE: "Project.Phase.Advance",
    PROJECT_STAKEHOLDER_EDIT: "Project.Stakeholder.Edit",
    PROJECT_SUPPORT_VIEW: "Project.Support.View",
    PROJECT_EXPORT_JSON: "Project.Export.Json",
    PROJECT_CREATE_LEGACY: "Project.Create.Legacy",
    PROJECT_EDIT_LEGACY: "Project.Edit.Legacy",

    EVALUATION_CRITERIA_VIEW_EXECUTION_QUERY: "EvaluationCriteria.ViewExecutionQuery",

    ASK_AI_VIEW_DEBUG_INFO: "AskAi.ViewDebugInfo",
    ASK_AI_KNOWLEDGE_BASE: "AskAi.KnowledgeBase",

    DATA_HERO_VIEW: "Data_Hero.View",
    DATA_HERO_RAW_DATA: "Data_Hero.RawData",

    KNOWLEDGE_BASE_MANAGE: "KnowledgeBase.Manage",
    KNOWLEDGE_BASE_COMMENT: "KnowledgeBase.Comment",

    SETTINGS_TRANSLATION_COMPONENT_CODE: "STTRL",
    SETTINGS_TRANSLATION_VIEW: "Settings_Translation.View",
    SETTINGS_TRANSLATION_MASTER: "Settings_Translation.Master",
    SETTINGS_TRANSLATION_EDIT: "Settings_Translation.Edit",
    SETTINGS_TRANSLATION_ADD_LANGUAGE: "Settings_Translation.AddLanguage",
    SETTINGS_TRANSLATION_ADD_TAG: "Settings_Translation.AddTag",
    SETTINGS_TRANSLATION_DELETE_TAG: "Settings_Translation.DeleteTag",
    SETTINGS_TRANSLATION_DELETE_LANGUAGE: "Settings_Translation.DeleteLanguage",

    SETTINGS_CONFIDENTIAL_SHARE_COMPONENT_CODE: "CFLSH",
    SETTINGS_CONFIDENTIAL_SHARE_USE: "Settings_Confidential_Share.Use",

    SETTINGS_PLATFORM_COMPONENT_CODE: "STPLF",
    SETTINGS_PLATFORM_VIEW: "Settings_Platform.View",

    CUSTOM_CALCULATION_COMPONENT_CODE: "CUCAL",
    CUSTOM_CALCULATION_PRO: "Custom_Calculation.Pro",

    SAVED_FILTER_USE: "SavedFilter.Use",
} as const;

const LEGACY_GLOBAL_TRANSLATION_MASTER_PERMISSION = "Dynamic_Translation.Master";
const LEGACY_GLOBAL_TRANSLATION_VIEW_PERMISSION = "Dynamic_Translation.View";
const LEGACY_DYNAMIC_TRANSLATION_MASTER_PERMISSION = "DynamicTranslation.Master";
const LEGACY_DYNAMIC_TRANSLATION_VIEW_PERMISSION = "DynamicTranslation.View";

export const SETTINGS_TRANSLATION_VIEW_PERMISSIONS = [
    DASHLY_PERMISSIONS.SETTINGS_TRANSLATION_VIEW,
    DASHLY_PERMISSIONS.SETTINGS_TRANSLATION_MASTER,
    DASHLY_PERMISSIONS.SETTINGS_TRANSLATION_EDIT,
    DASHLY_PERMISSIONS.SETTINGS_TRANSLATION_ADD_LANGUAGE,
    DASHLY_PERMISSIONS.SETTINGS_TRANSLATION_ADD_TAG,
    DASHLY_PERMISSIONS.SETTINGS_TRANSLATION_DELETE_TAG,
    DASHLY_PERMISSIONS.SETTINGS_TRANSLATION_DELETE_LANGUAGE,
    LEGACY_GLOBAL_TRANSLATION_MASTER_PERMISSION,
    LEGACY_GLOBAL_TRANSLATION_VIEW_PERMISSION,
    LEGACY_DYNAMIC_TRANSLATION_MASTER_PERMISSION,
    LEGACY_DYNAMIC_TRANSLATION_VIEW_PERMISSION,
] as const;

export const SETTINGS_TRANSLATION_GLOBAL_VIEW_PERMISSIONS = [
    DASHLY_PERMISSIONS.SETTINGS_TRANSLATION_MASTER,
    LEGACY_GLOBAL_TRANSLATION_MASTER_PERMISSION,
    LEGACY_GLOBAL_TRANSLATION_VIEW_PERMISSION,
    LEGACY_DYNAMIC_TRANSLATION_MASTER_PERMISSION,
    LEGACY_DYNAMIC_TRANSLATION_VIEW_PERMISSION,
] as const;

export const SETTINGS_TRANSLATION_EDIT_PERMISSIONS = [
    DASHLY_PERMISSIONS.SETTINGS_TRANSLATION_EDIT,
    DASHLY_PERMISSIONS.SETTINGS_TRANSLATION_MASTER,
    LEGACY_GLOBAL_TRANSLATION_MASTER_PERMISSION,
    LEGACY_DYNAMIC_TRANSLATION_MASTER_PERMISSION,
] as const;

export const SETTINGS_TRANSLATION_GLOBAL_EDIT_PERMISSIONS = [
    DASHLY_PERMISSIONS.SETTINGS_TRANSLATION_MASTER,
    LEGACY_GLOBAL_TRANSLATION_MASTER_PERMISSION,
    LEGACY_DYNAMIC_TRANSLATION_MASTER_PERMISSION,
] as const;
